import { UPDATE_APP } from './types';

export const updateApp = (data: any) => {
  return {
    type: UPDATE_APP,
    payload: data,
  };
};
